import axios from 'axios';

class DeliveryDataService {
    get(id: any, callback: any) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/delivery/${id}`;
        axios.get(url).then((response) => {
            callback(null, response.data);
        }).catch((error: any) => {
            callback(error, null);
        });
    }
    getDeliveryItem(id: any, callback: any) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/deliveryItem/${id}`;
        axios.get(url).then((response) => {
            callback(null, response.data);
        }).catch((error) => {
            callback(error, null);
        });
    }
    getDeliveryKit(id: any, callback: any) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/deliveryKit/${id}`;
        axios.get(url).then((response) => {
            callback(null, response.data);
        }).catch((error) => {
            callback(error, null);
        });
    }
    // Per-condition check-in counts. The server derives the item status from
    // the worst condition (missing > damaged > returning > satisfactory).
    updateDeliveryItemCounts(
        itemUuid: string,
        deliveryUuid: string,
        counts: { quantity_received_iwo?: number; quantity_damaged?: number; quantity_missing?: number; quantity_returning?: number },
        callback: any
    ) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/deliveryItem/${itemUuid}`;
        axios.patch(url, { delivery_uuid: deliveryUuid, ...counts }).then((response) => {
            callback(null, response.data);
        }).catch((error) => {
            callback(error, null);
        });
    }
    uploadDeliveryItemComment(itemUuid: string, deliveryUuid: string, comment: string, name: string, phone: string, callback: any) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/create_delivery_item_comment/${itemUuid}`;
        axios.post(url, {
            delivery_uuid: deliveryUuid,
            comment: comment,
            name: name,
            phone: phone
        }).then((response) => {
            callback(null, response.data);
        }).catch((error) => {
            callback(error, null);
        });
    }
    getDeliveryHistoryByUUID(fullUUID: string, callback: any) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/delivery_history/${fullUUID}`;
        axios.get(url).then((response) => {
            callback(null, response.data);
        }).catch((error) => {
            callback(error, null);
        });
    }
    getDeliveryCommentsByUUID(fullUUID: string, callback: any) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/delivery_comments/${fullUUID}`;
        axios.get(url).then((response) => {
            callback(null, response.data);
        }).catch((error) => {
            callback(error, null);
        });
    }
    search(uuid: string, searchString: string, callback: any) {
        const url = `${process.env.VUE_APP_API_URL}/mobile/kit_and_item_search/${uuid}`;
        axios.get(url, { params: { search_string: searchString } }).then((response) => {
            callback(null, this.parseSearchResults(response.data));
        }).catch((error) => {
            callback(error, null);
        });
    }
    parseSearchResults(results: any) {
        const searchResults = [] as any[];
        results.forEach(function (result: any) {
            if ('quantity_received_iwo' in result) {
                if ('DeliveryKit' in result) {
                    searchResults.push({type: 'item', uuid: result.uuid, number: (result.number + " (in kit:" + result.DeliveryKit.number + ")")});
                } else {
                    searchResults.push({type: 'item', uuid: result.uuid, number: result.number});
                }
            } else {
                if ('Parent' in result && result.Parent != null) {
                    searchResults.push({type: 'kit', uuid: result.uuid, number: (result.number + " (parent of kit:" + result.Parent.number + ")")});
                } else {
                    searchResults.push({type: 'kit', uuid: result.uuid, number: (result.number)});
                }
            }
        });
        return searchResults;
    }
}
export default new DeliveryDataService();
